export default {
    CPF: 1,
    RG: 2,
    CNH: 3,
    CNS: 4,
    CNPJ: 5,
}